import {
  COMPLETION_NOT_STARTED,
  COMPLETION_STARTED,
  COMPLETION_COMPLETE,
} from "%/dynamic-component-editor/stores/completion-status-store";

export const COMPLETION_STATE_ELEMENT_TYPES = ["CompletionStatus", "CompletionToggle"];

// XXX: CompletionStatus.vue and CompletionToggle.vue are identical apart from
// XXX: name/displayName/displayIcon, and they persist the SAME three option
// XXX: keys. elementType is therefore the only thing in the whole chain that
// XXX: can say which slot family a picker should resolve. Keep it a lookup, not
// XXX: a ternary: a ternary has to pick a loser, and the loser was "status",
// XXX: which silently offered Toggle authors the Status cards.
export const COMPLETION_SLOT_PREFIX_BY_ELEMENT_TYPE = {
  CompletionStatus: "status",
  CompletionToggle: "toggle",
};

export const COMPLETION_PREVIEW_STATES = [
  COMPLETION_NOT_STARTED,
  COMPLETION_STARTED,
  COMPLETION_COMPLETE,
];

export const PREVIEW_STATE_LABELS = {
  [COMPLETION_NOT_STARTED]: "Not started",
  [COMPLETION_STARTED]: "In progress",
  [COMPLETION_COMPLETE]: "Complete",
};

// Two-state mode has no "started".
export function availablePreviewStates(isTwoStateMode) {
  return isTwoStateMode
    ? [COMPLETION_NOT_STARTED, COMPLETION_COMPLETE]
    : [...COMPLETION_PREVIEW_STATES];
}

// Mirrors the assignment store's normalizeStatus so canvas matches production.
export function normalizePreviewStatus(status, isTwoStateMode) {
  if (!COMPLETION_PREVIEW_STATES.includes(status)) {
    return COMPLETION_NOT_STARTED;
  }
  if (isTwoStateMode && status === COMPLETION_STARTED) {
    return COMPLETION_NOT_STARTED;
  }
  return status;
}
